// Admin -> Sheets import (4 qadam), en — manba
export default {
  title: "Sheets import",
  subtitle: "One-time import of the current Google Sheets · done together with the dev team",
  ownerOnly: "Owner only",
  ownerOnlyDesc: "Only the owner can import data.",
  steps: { connect: "Connect sheet", map: "Map columns", preview: "Preview & duplicates", import: "Import" },
  connect: {
    fileRead: "File read",
    fileReadDesc: "{{rows}} rows · {{cols}} columns",
    fileFailed: "Could not read the file.",
    pasteLink: "Paste the Google Sheets link.",
    sheetConnected: "Sheet connected",
    sheetConnectedDesc: "{{rows}} rows",
    sheetFailed: "Could not connect to the sheet.",
    uploadTitle: "Upload a file",
    uploadDesc: "CSV or XLSX exported from Google Sheets",
    dropHere: "Drop a file here or",
    browse: "browse",
    limit: "CSV or XLSX, up to 20 MB",
    howTo: "In Google Sheets: File → Download → CSV (one tab per file).",
    template: "Download template",
    readFile: "Read file",
    linkTitle: "Google Sheets link",
    linkDesc: "Connect the live sheet through the Sheets API",
    sheetUrl: "Sheet URL",
    tabName: "Tab name",
    tabHint: "Leave empty for the first tab",
    shareWith: "Share the sheet with:",
    notConfigured: "Google Sheets connection is not configured yet — upload a CSV/XLSX export instead.",
    connectSheet: "Connect sheet",
    googleConnected: "Reading as {{email}}",
    googleConnectedHint: "The sheet must belong to this Google account or be shared with it.",
    googleReauth: "Google access has expired.",
    googleReconnectLink: "Reconnect in Settings → Integrations",
    googleNotConnected: "No Google account is connected.",
    googleConnectLink: "Connect in Settings → Integrations",
    googleOrShare: "Or share the sheet with the service account:",
    previous: "Previous imports",
    noImports: "No imports yet.",
    col: { file: "File / sheet", when: "When", who: "Who", status: "Status", rows: "Rows", imported: "Imported", errors: "Errors" },
    importN: "Import #{{id}}",
  },
  status: { uploaded: "Uploaded", mapped: "Mapped", previewed: "Previewed", importing: "Importing", done: "Done", failed: "Failed" },
  map: {
    phoneRequired: "Map the Phone column: it is required.",
    usedTwice: "The same field is used twice: {{fields}}.",
    saveFailed: "Could not save the mapping.",
    connected: "Connected:",
    rowsCols: "{{rows}} rows · {{cols}} columns",
    tabs: "tabs: {{tabs}}",
    columnMapping: "Column mapping",
    step2: "step 2",
    col: { sheet: "Sheet column", sample: "Sample value", field: "Field in the system", req: "Req." },
    fieldFor: "Field for {{col}}",
    yes: "yes",
    twice: "used twice",
    skipped: "skipped",
    ok: "✓ ok",
    phoneHint: "Phone is required: choose the column with phone numbers.",
    statusValues: "Status values",
    statusSubtitle: "{{n}} values in the sheet · {{unmapped}} unmapped",
    noStatusColumn: "No status column mapped — everyone starts as New",
    inSheet: "In the sheet",
    inSystem: "In the system",
    statusFor: "Status for {{raw}}",
    mapStatusHint: "Map a column to “Status” above to translate the sheet’s wording into pipeline statuses.",
    owner: "Owner",
    ownerDesc: "Who gets the imported drivers",
    useColumn: "Use the Recruiter column",
    useColumnHint: "Names or emails are matched to users; unresolved → default owner below.",
    useColumnMissing: "Map a column to “Recruiter (owner)” first.",
    single: "Assign everyone to one recruiter",
    pool: "No owner (branch / team pool)",
    poolHint: "Team lead assigns later.",
    recruiter: "Recruiter",
    defaultOwner: "Default owner (for unresolved names)",
    nonePool: "— none (pool) —",
    branch: "Branch",
    choose: "— choose —",
    team: "Team",
    branchPool: "— branch pool —",
    defaultSource: "Default source",
    defaultSourceHint: "Used when the Source column is empty or not mapped",
    nothingWritten: "Nothing is written until you press Import.",
    back: "Back",
    savePreview: "Save mapping & preview",
  },
  preview: {
    imported: "Imported {{n}} drivers",
    failed: "Import failed.",
    failedTitle: "Import failed",
    step2done: "step 2, done",
    ownerFrom: "Owner:",
    ownerColumn: "from the Recruiter column",
    ownerSingle: "one recruiter",
    ownerPool: "branch / team pool",
    unresolved: "{{n}} rows without a resolved owner (go to pool)",
    statusUnmapped: "{{n}} status values unmapped → New",
    title: "Preview",
    step3: "step 3",
    rowsFound: "Rows found",
    ready: "Ready to import",
    duplicates: "Duplicates merged",
    errors: "Errors (not imported)",
    reformatted: "Phone numbers reformatted",
    whyFail: "Why {{n}} rows fail",
    dupHint: "Duplicates: a driver that already exists (same phone or CDL) is skipped — the existing record keeps its owner. Example: a driver in two recruiters’ sheets becomes one record owned by the recruiter who added them first.",
    downloadErrors: "Download error rows",
    notImported: "Rows not imported ({{n}})",
    notImportedDesc: "First 20 shown · fix them in the sheet and import again",
    col: { row: "Row", reason: "Reason", values: "Values" },
    transaction: "Nothing is written until you press Import. The import runs as one transaction: all rows or none.",
    importing: "Importing…",
    importN: "Import {{n}} drivers",
  },
  done: {
    importing: "Importing…",
    failed: "Import failed — nothing was written",
    unknown: "Unknown error.",
    backToPreview: "Back to preview",
    another: "Start another import",
    imported: "Imported {{n}} drivers",
    history: "each driver’s history shows “Imported from …”",
    rowsFound: "Rows found",
    importedLabel: "Imported",
    duplicates: "Duplicates merged",
    errors: "Errors (not imported)",
    goDrivers: "Go to Drivers",
  },
};
